import React from "react";

import {
  Section,
  ICarousel,
  IHero,
  IHeroVideoBg,
  IHeroSideBySide,
  IIconRow,
  IIcon,
  I1Column,
  I1ColumnSlideshow,
  I2Column,
  I3Column,
  I4Column,
  IInsertSnippet,
  IPeekabooRow,
  ITestimonialCarousel,
  IFeaturedPost,
  IFeaturedPostsRow,
  IToc2Column
} from "../../../interfaces";
import { COMPONENTS } from "../../../constants";
import { parameterize } from "../../../utils";

import CssOverride from "../../css-override";
import { Hero, HeroVideoBg, HeroSideBySide } from "../../heroes";
import Carousel from "../../carousel";
import TestimonialCarousel from "../../testimonial-carousel";
import FeaturedPostsRow from "../../featured-posts-row";
import FeaturedPost from "../../featured-post";
import { Icon, IconRow } from "../../icons";
import PeekabooRow from "../../peekaboo-row";
import { Col1, Col1Slideshow, Col2, Col3, Col4, Toc2Column } from "../../column-sections";
import SnippetBroker from "../../brokers/snippet-broker";

interface Props {
  section: Section;
}

class SectionBroker extends React.Component<Props, {}> {
  FormattedComponent;

  constructor(props) {
    super(props);

    const { section } = this.props;
    const componentType = section.__typename || section.component;

    switch (componentType) {
      case COMPONENTS.ICON_ROW:
        this.FormattedComponent = CssOverride(IconRow, section as IIconRow);
        break;
      case COMPONENTS.CAROUSEL:
        this.FormattedComponent = CssOverride(Carousel, section as ICarousel);
        break;
      case COMPONENTS.TESTIMONIAL_CAROUSEL:
        this.FormattedComponent = CssOverride(TestimonialCarousel, section as ITestimonialCarousel);
        break;
      case COMPONENTS.FEATURED_POSTS_ROW:
        this.FormattedComponent = CssOverride(FeaturedPostsRow, section as IFeaturedPostsRow);
        break;
      case COMPONENTS.HERO:
        this.FormattedComponent = CssOverride(Hero, section as IHero);
        break;
      case COMPONENTS.HERO_VIDEO_BG:
        this.FormattedComponent = CssOverride(HeroVideoBg, section as IHeroVideoBg);
        break;
      case COMPONENTS.HERO_SIDE_BY_SIDE:
        this.FormattedComponent = CssOverride(HeroSideBySide, section as IHeroSideBySide);
        break;
      case COMPONENTS.COLUMN_1:
        this.FormattedComponent = CssOverride(Col1, section as I1Column);
        break;
      case COMPONENTS.COLUMN_1_SLIDESHOW:
        this.FormattedComponent = CssOverride(Col1Slideshow, section as I1ColumnSlideshow);
        break;
      case COMPONENTS.COLUMN_2:
        this.FormattedComponent = CssOverride(Col2, section as I2Column);
        break;
      case COMPONENTS.COLUMN_3:
        this.FormattedComponent = CssOverride(Col3, section as I3Column);
        break;
      case COMPONENTS.COLUMN_4:
        this.FormattedComponent = CssOverride(Col4, section as I4Column);
        break;
      case COMPONENTS.TOC_2_COLUMN:
        this.FormattedComponent = CssOverride(Toc2Column, section as IToc2Column);
        break;
      case COMPONENTS.INSERT_SNIPPET:
        this.FormattedComponent = () => {
          let snippet = (section as IInsertSnippet).snippet;
          snippet["custom_data"] = (section as IInsertSnippet).custom_data || {};

          return (
            <>
              <SnippetBroker {...snippet} />
            </>
          );
        };
        break;
      case COMPONENTS.FEATURED_POST:
        this.FormattedComponent = CssOverride(FeaturedPost, section as IFeaturedPost);
        break;
      case COMPONENTS.PEEKABOO_ROW:
        this.FormattedComponent = CssOverride(PeekabooRow, section as IPeekabooRow);
        break;
      default:
        console.warn(`${section.component} does not exist.`);
    }
  }

  render() {
    const {
      section: { id: entry_id, component, name }
    } = this.props;
    const id = !name || name === component ? `section-${entry_id}` : parameterize(name);

    return (
      <div id={id} className="section">
        {this.FormattedComponent && <this.FormattedComponent />}
      </div>
    );
  }
}

export default SectionBroker;
